export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5563984042819"
      target="_blank"
      rel="noreferrer"
      aria-label="Fale pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
    >
      <i className="fa-brands fa-whatsapp text-3xl" />
    </a>
  )
}
